import { request } from './utils';

export default class PaymentService {
    static async create(payment) {
        const { loanNumber, ...paymentData } = payment;
        const response = await request(`/api/loans/${loanNumber}/payments`, {
            method: 'POST',
            data: paymentData
        });

        return response;
    }

    static async bulkInstantReleaseProcessingPayments(ids) {
        // DPP used to reshape this into { payment_ids: [...].flat() } before
        // forwarding to P4's release endpoint.
        const response = await request('/api/payments/releases', {
            method: 'POST',
            data: { paymentIds: [ids].flat() }
        });

        return response.data;
    }
}
